const Order = {
    namespaced: true,
    state: {
        orders: [],
        view: 'all'
    },
    mutations: {
        SET_VIEW: (state, view) => {
            state.view = view
        }
    },
    actions: {
        setView({
            commit
        }, data) {
            commit('SET_VIEW', data)
            return data
        },
    },
}

export default Order